// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiltersOrdersRow_title-back__yUXoN {
  margin-bottom: 16px;
}

.FiltersOrdersRow_search__MknRg {
  margin-bottom: 24px;
}
@media (min-width: 640px) {
  .FiltersOrdersRow_search__MknRg {
    margin-bottom: 31px;
  }
}

.FiltersOrdersRow_coordination-container__cHGlL {
  margin-bottom: 32px;
}
.FiltersOrdersRow_coordination-container__cHGlL ~ .FiltersOrdersRow_coordination-container__cHGlL {
  margin-bottom: 0;
}
.FiltersOrdersRow_coordination-container__cHGlL .FiltersOrdersRow_title__4GlM- {
  margin-bottom: 12px;
  font-weight: 600;
}

.FiltersOrdersRow_list-container__mtTKU {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.FiltersOrdersRow_skeleton__yL93e,
.FiltersOrdersRow_item__GCVNX {
  margin-bottom: 12px;
}
.FiltersOrdersRow_skeleton__yL93e:last-child,
.FiltersOrdersRow_item__GCVNX:last-child {
  margin-bottom: 0;
}
@media (min-width: 768px) {
  .FiltersOrdersRow_skeleton__yL93e,
  .FiltersOrdersRow_item__GCVNX {
    margin-bottom: 0;
  }
}

.FiltersOrdersRow_skeleton__yL93e {
  width: 100%;
  height: 164px;
  border-radius: 12px;
}
.FiltersOrdersRow_skeleton--sm__FCy1f {
  height: 34px;
  margin-bottom: 2px;
}

.FiltersOrdersRow_nothing__\\+kiBp {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 114%;
  margin: auto;
  width: 100%;
}
@media (min-width: 1200px) {
  .FiltersOrdersRow_nothing__\\+kiBp {
    margin: 20px auto;
    position: initial;
  }
}

.FiltersOrdersRow_filters-container__YUbMP {
  margin-bottom: 16px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
@media (max-width: 640px) {
  .FiltersOrdersRow_filters-container__YUbMP {
    margin-bottom: 0;
  }
}

.FiltersOrdersRow_members-filter__G9E2\\+ .btn__text-container {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Coordinations/CoordinationsFilters/CoordinationsFilters.module.scss","webpack://./src/components/FiltersOrdersRow/FiltersOrdersRow.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;ACCF;;ADEA;EACE,mBAAA;ACCF;ADCE;EAHF;IAII,mBAAA;ECEF;AACF;;ADGE;EACE,mBAAA;ACAJ;ADGE;EACE,gBAAA;ACDJ;ADIE;EACE,mBAAA;EACA,gBAAA;ACFJ;;ADMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACHF;;ADMA;;EAEE,mBAAA;ACHF;ADKE;;EACE,gBAAA;ACFJ;ADKE;EARF;;IASI,gBAAA;ECDF;AACF;;ADIA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;ACDF;ADGE;EACE,YAAA;EACA,kBAAA;ACDJ;;ADKA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;ACFF;ADIE;EARF;IASI,iBAAA;IACA,iBAAA;ECDF;AACF;;ADIA;EACE,mBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;ACDF;ADGE;EANF;IAOI,gBAAA;ECAF;AACF;;ADKI;EACE,aAAA;EACA,mBAAA;ACFN","sourcesContent":[".title-back {\n  margin-bottom: 16px;\n}\n\n.search {\n  margin-bottom: 24px;\n\n  @media (min-width: 640px) {\n    margin-bottom: 31px;\n  }\n}\n\n.coordination-container {\n\n  & {\n    margin-bottom: 32px;\n  }\n  \n  & ~ & {\n    margin-bottom: 0;\n  }\n\n  .title {\n    margin-bottom: 12px;\n    font-weight: 600;\n  }\n}\n\n.list-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.skeleton,\n.item {\n  margin-bottom: 12px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (min-width: 768px) {\n    margin-bottom: 0;\n  }\n}\n\n.skeleton {\n  width: 100%;\n  height: 164px;\n  border-radius: 12px;\n\n  &--sm {\n    height: 34px;\n    margin-bottom: 2px;\n  }\n}\n\n.nothing {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 114%;\n  margin: auto;\n  width: 100%;\n\n  @media (min-width: 1200px) {\n    margin: 20px auto;\n    position: initial;\n  }\n}\n\n.filters-container {\n  margin-bottom: 16px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n\n  @media (max-width: 640px) {\n    margin-bottom: 0;\n  }\n}\n\n.members-filter {\n  :global {\n    .btn__text-container {\n      display: flex;\n      align-items: center;\n    }\n  }\n}",".title-back {\n  margin-bottom: 16px;\n}\n\n.search {\n  margin-bottom: 24px;\n}\n@media (min-width: 640px) {\n  .search {\n    margin-bottom: 31px;\n  }\n}\n\n.coordination-container {\n  margin-bottom: 32px;\n}\n.coordination-container ~ .coordination-container {\n  margin-bottom: 0;\n}\n.coordination-container .title {\n  margin-bottom: 12px;\n  font-weight: 600;\n}\n\n.list-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.skeleton,\n.item {\n  margin-bottom: 12px;\n}\n.skeleton:last-child,\n.item:last-child {\n  margin-bottom: 0;\n}\n@media (min-width: 768px) {\n  .skeleton,\n  .item {\n    margin-bottom: 0;\n  }\n}\n\n.skeleton {\n  width: 100%;\n  height: 164px;\n  border-radius: 12px;\n}\n.skeleton--sm {\n  height: 34px;\n  margin-bottom: 2px;\n}\n\n.nothing {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 114%;\n  margin: auto;\n  width: 100%;\n}\n@media (min-width: 1200px) {\n  .nothing {\n    margin: 20px auto;\n    position: initial;\n  }\n}\n\n.filters-container {\n  margin-bottom: 16px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n@media (max-width: 640px) {\n  .filters-container {\n    margin-bottom: 0;\n  }\n}\n\n.members-filter :global .btn__text-container {\n  display: flex;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title-back": `FiltersOrdersRow_title-back__yUXoN`,
	"search": `FiltersOrdersRow_search__MknRg`,
	"coordination-container": `FiltersOrdersRow_coordination-container__cHGlL`,
	"title": `FiltersOrdersRow_title__4GlM-`,
	"list-container": `FiltersOrdersRow_list-container__mtTKU`,
	"skeleton": `FiltersOrdersRow_skeleton__yL93e`,
	"item": `FiltersOrdersRow_item__GCVNX`,
	"skeleton--sm": `FiltersOrdersRow_skeleton--sm__FCy1f`,
	"nothing": `FiltersOrdersRow_nothing__+kiBp`,
	"filters-container": `FiltersOrdersRow_filters-container__YUbMP`,
	"members-filter": `FiltersOrdersRow_members-filter__G9E2+`
};
export default ___CSS_LOADER_EXPORT___;
